import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { insuranceOptions } from "../../data/choiceData";
import Footer from "../../components/landing/Footer";

function OptionCard({ option, onClick }) {
  return (
    <motion.button
      type="button"
      whileHover={{ y: -4, scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
      onClick={onClick}
      className="overflow-hidden relative text-left bg-white rounded-2xl ring-1 ring-gray-200 shadow-sm transition-all duration-300 cursor-pointer group focus:outline-none hover:shadow-xl hover:ring-2 hover:ring-emerald-400 focus:ring-2 focus:ring-emerald-400"
    >
      <div className="flex flex-col p-3 sm:p-4 md:p-5 lg:p-6 h-48 sm:h-56 md:h-64">
        <div className="flex flex-1 justify-center items-center min-h-0 mb-2 overflow-hidden">
          <img
            src={option.image}
            alt={option.title}
            className={`w-full h-full transition-all duration-300 object-contain ${option.key === "road-trip" ? "scale-150 group-hover:scale-[1.55]" : "group-hover:scale-105"}`}
          />
        </div>
        <div className="text-center">
          <h4 className="mb-1 text-sm font-semibold text-gray-900 sm:mb-1.5 sm:text-base md:mb-2 md:text-lg">
            {option.title}
          </h4>
          <p className="text-xs leading-tight text-gray-600 sm:text-xs md:text-sm md:leading-relaxed">
            {option.subtitle}
          </p>
        </div>
        <div className="absolute inset-0 bg-gradient-to-b transition-all duration-300 pointer-events-none from-emerald-50/0 via-emerald-50/0 to-emerald-50/0 group-hover:from-emerald-50/20 group-hover:via-emerald-50/10 group-hover:to-emerald-50/20" />
      </div>
    </motion.button>
  );
}

export default function InsuranceChoose() {
  const navigate = useNavigate();

  return (
    <section className="min-h-screen bg-gradient-to-br from-gray-50 to-white">
      <div className="px-4 pt-20 pb-12 sm:px-6 lg:px-8 sm:pt-24 sm:pb-16">
        <div className="mx-auto max-w-7xl">
          <div className="mb-8">
            <h1 className="text-2xl font-bold text-gray-900 sm:text-3xl">
              Choose Your Insurance
            </h1>
            <div className="mt-2 w-32 h-1 bg-emerald-500 rounded" />
            <p className="mt-3 text-sm text-gray-600 sm:text-base">
              Select an insurance type to view available policies and compare
              options.
            </p>
          </div>

          <motion.div
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.35 }}
            className="grid grid-cols-2 gap-3 sm:gap-4 md:grid-cols-3 lg:grid-cols-4"
          >
            {insuranceOptions.map((opt) => (
              <OptionCard
                key={opt.key}
                option={opt}
                onClick={() => opt.link && navigate(opt.link)}
              />
            ))}
          </motion.div>
        </div>
      </div>
      <Footer />
    </section>
  );
}
